import React from "react";

const EyeIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "3px", marginRight: "5px" }}
  >
    <path
      d="M8.79199 4.40015C3.79199 4.40015 1.79199 8.90063 1.79199 8.90063C1.79199 8.90063 3.79199 13.4001 8.79199 13.4001C13.792 13.4001 15.792 8.90063 15.792 8.90063C15.792 8.90063 13.792 4.40015 8.79199 4.40015Z"
      stroke="#339EEC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.79199 11.4006C10.1727 11.4006 11.292 10.2813 11.292 8.90063C11.292 7.51992 10.1727 6.40063 8.79199 6.40063C7.41128 6.40063 6.29199 7.51992 6.29199 8.90063C6.29199 10.2813 7.41128 11.4006 8.79199 11.4006Z"
      stroke="#339EEC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EyeIcon;
